export default "__VITE_ASSET__BGyVTW6t__"